import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_RATINGS_PATH_KEY } from '@/swagger/constants/contents-rating-keys';

export const API_PUT_CONTENTS_RATING = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_RATINGS_PATH_KEY, {
    organizationId,
  });
};
